// Source unique = utils/api (multi-tenant A5). Réexports conservés pour compat
// des imports existants (`import { BACKEND_URL, ALTERREGO_ENV } from '../config'`).
export { BACKEND_URL, ENV as ALTERREGO_ENV } from './utils/api';

// Feature flag carte cadeau. Désactivé par défaut (OFF) tant que la page de
// paiement Ciss n'est pas en place : la tuile « Carte cadeau » de l'accueil, la
// route /carte-cadeau et l'entrée du menu Compte sont masquées. Pour réactiver
// sur un stage donné : VITE_ENABLE_GIFT_CARDS=true dans son .env. Voir mémoire
// strategie_multitenant_ciss_paypage_adyen + docs/testflight-external-checklist.md.
export const GIFT_CARDS_ENABLED = (import.meta.env.VITE_ENABLE_GIFT_CARDS as string) === 'true';

// Feature flag « Vue pass » (/staff/resa-du-jour). OFF pour la beta staff : cet
// écran a été conçu (commit 4e6ccf0, 21 juin 2026) comme affichage mural iPad
// posé AU PASS — lecture à 2-3 m, polling 30 s, fond sombre — et ses actions
// tactiles sont précisément les statuts que le cahier beta retire de l'UI
// (Arrivée / No-show). Le laisser visible réintroduirait par la porte de service
// ce que la refonte des cards vient d'enlever.
// Le code est CONSERVÉ tel quel : seuls le bouton d'accès et la route sont
// masqués. Pour le réactiver sur un stage : VITE_SHOW_PASS_VIEW=true.
export const SHOW_PASS_VIEW = (import.meta.env.VITE_SHOW_PASS_VIEW as string) === 'true';
